(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-collections"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tm-orbit')) {
  customElements.define('tm-orbit', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.choices = [...this.querySelectorAll('[data-choice]')];
      this.current = 0;
      if (!this.cards.length) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.status = this.querySelector('[data-status]');
      this.statusTemplate = this.status.textContent.trim();
      this.setAttribute('data-ready','');
      this.querySelector('[data-jump]')?.addEventListener('change',event=>this.select(Number(event.target.value)),options);
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choice]');
        const step = event.target.closest('[data-step]');
        if (choice) this.select(Number(choice.dataset.choice));
        if (step) this.select(this.current + Number(step.dataset.step));
      }, options);
      this.addEventListener('keydown', event => {
        if (event.target.closest('select,input,textarea')) return;
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        this.select(event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.current + (event.key === 'ArrowRight' ? 1 : -1));
        this.choices[this.current].focus({preventScroll:true});
      }, options);
      const stage = this.querySelector('.tm-orbit__stage');
      stage.addEventListener('pointerdown', event => {this.start = {x:event.clientX,y:event.clientY,id:event.pointerId};}, options);
      stage.addEventListener('pointerup', event => {
        if (!this.start || this.start.id !== event.pointerId) return;
        const dx = event.clientX - this.start.x, dy = event.clientY - this.start.y;
        this.start = null;
        if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.3) {this.swiped=true;this.select(this.current+(dx<0?1:-1));}
      }, options);
      stage.addEventListener('pointercancel',()=>{this.start=null;},options);
      stage.addEventListener('click', event=>{if(this.swiped){event.preventDefault();this.swiped=false;}}, {...options,capture:true});
      document.addEventListener('shopify:block:select', event=>{
        const i=this.cards.findIndex(card=>card.dataset.block===event.detail.blockId);
        if(i>=0)this.select(i);
      }, options);
      this.select(0);
    }
    select(index) {
      const n=this.cards.length;
      this.current=((index%n)+n)%n;
      this.cards.forEach((card,i)=>{
        let offset=((i-this.current+n)%n);
        if(offset>Math.floor(n/2))offset-=n;
        card.style.setProperty('--offset',offset);
        const active=i===this.current;
        card.classList.toggle('is-active',active);
        card.classList.toggle('is-distant',Math.abs(offset)>1);
        card.inert=!active;
        card.setAttribute('aria-hidden',String(!active));
        this.choices[i].style.setProperty('--offset',offset);
        this.choices[i].setAttribute('aria-pressed',String(active));
        this.choices[i].classList.toggle('is-hidden',Math.abs(offset)>2);
        this.choices[i].tabIndex=Math.abs(offset)>2?-1:0;
      });
      if(this.querySelector('[data-jump]'))this.querySelector('[data-jump]').value=String(this.current);
      this.status.textContent=this.statusTemplate.replace(/\b1\b/,String(this.current+1));
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-offer-ticker"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tm-offer-ticker'))customElements.define('tm-offer-ticker',class extends HTMLElement{
connectedCallback(){this.button=this.querySelector('button');this.button.hidden=false;this.onToggle=()=>{const paused=this.toggleAttribute('data-paused');this.button.setAttribute('aria-pressed',String(paused));};this.button.addEventListener('click',this.onToggle);}
disconnectedCallback(){this.button?.removeEventListener('click',this.onToggle);}
});

  } catch(e) { console.error(e); }
})();
})();
